import { inject } from '@angular/core';
import type { CanActivateFn } from '@angular/router';
import { Router } from '@angular/router';

import { CustomerAuthSessionService } from '../services/customer-auth-session.service';

export const customerAuthGuard: CanActivateFn = () => {
  const session = inject(CustomerAuthSessionService);
  const router = inject(Router);
  if (session.isLoggedIn()) return true;
  void router.navigate(['/sign-in']);
  return false;
};
